module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "500",
      "min-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    staticStyle: {
      "width": "100%"
    },
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.title || 'Select a Contact'))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleAdding($event)
      }
    }
  }, [(_vm.adding) ? _c('v-icon', [_vm._v("list")]) : _c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [(_vm.adding) ? _c('div', {
    staticClass: "pa-4"
  }, [_c('ContactDetails', {
    ref: "contactDetails",
    attrs: {
      "contact": _vm.contact
    }
  })], 1) : [_c('ContactSearch', {
    attrs: {
      "role": _vm.data.role,
      "visible": _vm.dialogVisible
    },
    on: {
      "click": _vm.select,
      "add": _vm.toggleAdding
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [(_vm.adding) ? [_c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveAndSelect($event)
      }
    }
  }, [_vm._v("Save and Select")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedCancel($event)
      }
    }
  }, [_vm._v("Cancel")])] : [_c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedCancel($event)
      }
    }
  }, [_vm._v("Cancel")])]], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74f763d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ContactSelector.vue
// module id = 2607
// module chunks = 1